import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	appealLabel__action__list: 'mw/appeal_label/action/list',
};

export const appealLabelApi = createApi({
	reducerPath: 'mw/appealLabelApi',

	endpoints: (builder) => ({
		appealLabelActionList: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/appeal_label/action/list',
				jsonType: true,
				body,
			}),
			providesTags: [tags.appealLabel__action__list],
		}),
	}),
});

export const {
	appealLabelActionList,
} = appealLabelApi.endpoints;

export default appealLabelApi;